import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CreatorService } from '../../services/creator.service';
import { Creator } from '../../models/creator';
import { AgentService } from '../../services/agent.service';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { CommonModule } from '@angular/common';
import { Campaign } from '../../models/campaign';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-creator',
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './creator.component.html',
  styleUrl: './creator.component.css'
})
export class CreatorComponent implements OnInit {
  creator!: Creator;
  showCreateNewCampaign: boolean = false;
  newCampaign?: Campaign;

  companies: Company[] = [];

  constructor(private route: ActivatedRoute, private creatorService: CreatorService, private agentService: AgentService, private companyService: CompanyService) {}

  getBrandName(brandId: string | undefined): string {
    if (!brandId) return '';
    return this.companies.find(c => c.id === brandId)?.name ?? '';
  }

  ngOnInit(): void {
    const creatorId = this.route.snapshot.paramMap.get('id')!;

    this.creatorService.getCreator(creatorId).subscribe((result) => {
      this.creator = result;
    });
    this.companyService.getCompanies().subscribe(companies => { this.companies = companies; });

  }

  AddCampaign() {

  }


}
